/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_CueInputs */

const en_us2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form tip`)
};

const pt_br2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dica de execução`)
};

const es_419_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consejo de técnica`)
};

const pt_pt2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dica de execução`)
};

const fr_fr2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conseil d'exécution`)
};

const de_de2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technik-Tipp`)
};

const it_it2_exercise_cue = /** @type {(inputs: Exercise_CueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consiglio di esecuzione`)
};

/**
* | output |
* | --- |
* | "Form tip" |
*
* @param {Exercise_CueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_cue = /** @type {((inputs?: Exercise_CueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_CueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_cue(inputs)
	if (locale === "es-419") return es_419_exercise_cue(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_cue(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_cue(inputs)
	if (locale === "de-DE") return de_de2_exercise_cue(inputs)
	if (locale === "it-IT") return it_it2_exercise_cue(inputs)
	return en_us2_exercise_cue(inputs)
});
export { exercise_cue as "exercise.cue" }